<template>
	<div>

		<el-form ref="form" :model="addRechargeFrom" label-width="120px">
			<el-form-item label="请选择套餐" required>
				<!-- <el-select v-model="addRechargeFrom.id" filterable placeholder="请选择套餐">
					<el-option v-for="item in setmealArr" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select> -->
				<div class="div-box">
					<div class="system">
						<el-button type="primary" @click="AddSetmeal">增加套餐</el-button>
						<el-button type="danger" @click="deleteSetmeal">删除套餐</el-button>
					</div>
					<el-radio-group v-model="addRechargeFrom.meal_id" size="small">
						<el-radio class="radio-item" :label="item.id" border v-for="item in setmealArr"
							:key="item.value">
							{{item.meal_name}}
						</el-radio>
					</el-radio-group>
				</div>
			</el-form-item>
      
      <el-form-item label="充值套餐数量" required>
        <div>
          <el-input-number controls-position="right" :precision="0" v-model.number="addRechargeFrom.package_num" :min="1" type="number" placeholder="请输入充值套餐数量"></el-input-number>
        </div>
      </el-form-item>

			<el-form-item label="充值凭证">
				<div class="upload-main" v-if="ossData.ossAccessKeyId">
					<uploadRechargeImg @handleSuccess='RechargImgSuccess($event,index)'
						@handleRemove='RechargImgRemove($event,index)' :ossData='ossData' :ossObj="ossObj"
						class="upload-item" v-for="(item,index) in 3" :key="index"></uploadRechargeImg>
				</div>
			</el-form-item>
			<el-form-item>
				<el-button :disabled="loading" type="primary" @click="addRechargeSubmit">保存</el-button>
			</el-form-item>
		</el-form>

	</div>
</template>

<script>
	import uploadRechargeImg from './uploadRechargeImg.vue'

	export default {
		components: {
			uploadRechargeImg,
		},
		props: ['id', 'type', 'setmealArr'],
		data() {
			return {
        loading:false,
				ossData: {},
				ossObj: {},
				addRechargeFrom: {
          package_num:1,
					meal_id: '',
					recharge_pic1: '',
					recharge_pic2: '',
					recharge_pic3: '',
				},

			};
		},

		methods: {
			AddSetmeal() {
				this.$emit('add')
			},
			deleteSetmeal() {
				this.$emit('delete')
			},

			async addRechargeSubmit() {
				//校验格式

				if (!this.addRechargeFrom.meal_id) {
					return this.$message.error('套餐不能为空')
				}
        
        if (!this.addRechargeFrom.package_num) {
          return this.$message.error('套餐数量不能为空')
        }else if (isNaN(this.addRechargeFrom.package_num)) {
          return this.$message.error('套餐数量只能是数字')
        }else if (Math.floor(this.addRechargeFrom.package_num)<=0){
          return this.$message.error('套餐数需要大于0')
        }

				let requireLen = Object.values(this.addRechargeFrom).filter(item => item)


				//校验填写数量
				if (requireLen < 2) {
					return this.$message.error('至少上传一张凭证')
				}
				let activeSetmeal = this.$props.setmealArr.find((item) => {
					return item.id == this.addRechargeFrom.meal_id
				})
        this.loading=true;
				const res = await this.$api.postRechargeSetMeal({
					company_id: this.$props.id,
					company_type: this.$props.type,
					meal_name: activeSetmeal.meal_name,
					...this.addRechargeFrom,
          package_num:Math.floor(this.addRechargeFrom.package_num)
				})
				if (res) {
					this.$emit('success', 'isShowSetMeal')
				}
			},
			//移除
			RechargImgRemove(url, index) {
				this.addRechargeFrom['recharge_pic' + (index + 1)] = ''
			},
			//成功
			RechargImgSuccess(url, index) {
				this.addRechargeFrom['recharge_pic' + (index + 1)] = url

			},
			//oss上传
			async ossUpload() {
				const res_oss = await this.$api.getOss({
					dir: 'ph/hr/'
				})
				if (res_oss) {
					this.ossObj = res_oss
					this.ossData = {
						ossAccessKeyId: res_oss.accessid,
						policy: res_oss.policy,
						signature: res_oss.signature
					}
				} else {
					this.$message.error('获取oss签名失败')
				}
			},

		},
		created() {
			this.ossUpload()
		},
		mounted() {
			console.log(this.$props)
		},
	};
</script>

<style lang="scss" scoped>
/deep/	.el-radio {
		margin-bottom: 10px;
	}

	.system {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;

	}

	.upload-main {
		display: flex;
		justify-content: flex-start;
	}

	.upload-item {
		margin-right: 25px;
	}
</style>
